__turbopack_context__.v({
  "icon": "LoginButton-module__vOfPYq__icon",
  "loginButton": "LoginButton-module__vOfPYq__loginButton",
});
